import { render } from "./UserMain.vue?vue&type=template&id=bb0d87ba"
import script from "./UserMain.vue?vue&type=script&lang=js"
export * from "./UserMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__